import GT from '!raw-loader!./GT.md';
import CR from '!raw-loader!./CR.md';

const GTvariables = {
  CLARO: '“Mi Pago Claro”, Telecomunicaciones de Guatemala, Sociedad Anónima y Claro Guatemala, S.A. (en adelante CLARO GUATEMALA)',
  PAIS: 'GUATEMALA',
  COUNTRY_CODE: 'gt',
  PAIS_CAPITALIZE: 'Guatemala',
  NUMERO_TELEFONICO: '147-100'
};

const HNvariables = {
  CLARO: '“Mi Pago Claro”, Servicios de Comunicaciones de Honduras, sociedad anónima de capital variable (en adelante CLARO HONDURAS)',
  PAIS: 'HONDURAS',
  COUNTRY_CODE: 'hn',
  PAIS_CAPITALIZE: 'Honduras',
  NUMERO_TELEFONICO: '3390-0000 / 2205-0000 o *11, *1'
};

const NIvariables = {
  CLARO: '“Mi Pago Claro”, Empresa Nicaragüense de Telecomunicaciones, Sociedad Anónima (en adelante CLARO NICARAGUA)',
  PAIS: 'NICARAGUA',
  COUNTRY_CODE: 'ni',
  PAIS_CAPITALIZE: 'Nicaragua',
  NUMERO_TELEFONICO: '121'
};

const PAvariables = {
  CLARO: '“Mi Pago Claro”, Claro Panamá, Sociedad Anónima (en adelante CLARO PANAMÁ)',
  PAIS: 'PANAMÁ',
  COUNTRY_CODE: 'pa',
  PAIS_CAPITALIZE: 'Panamá',
  NUMERO_TELEFONICO: '800-9100 o *611'
};

const SVvariables = {
  CLARO: '“Mi Pago Claro”, Compañía de Telecomunicaciones de El Salvador, Sociedad Anónima de Capital Variable (en adelante CLARO EL SALVADOR)',
  PAIS: 'SALVADOR',
  COUNTRY_CODE: 'sv',
  PAIS_CAPITALIZE: 'Salvador',
  NUMERO_TELEFONICO: '2250-5555 o *85'
};

const setVariables = (text, variables) => () => {
  Object.entries(variables).forEach(([key, value]) => {
    const regexp = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
    // eslint-disable-next-line no-param-reassign
    text = text.replace(regexp, value);
  });
  return text;
};

export default {
  // GT: setVariables(GT, GTvariables),
  GT: setVariables(GT, GTvariables),
  CR: () => CR,
  HN: setVariables(GT, HNvariables),
  PA: setVariables(GT, PAvariables),
  NI: setVariables(GT, NIvariables),
  SV: setVariables(GT, SVvariables)
};
